import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  filled: "dibf1o4rouo",
  compact: "dibcx2402o"
});
const inputWrapper = "dibitzv2yx";
const globalThemeSearchButton = "dibg18q2er5";
const input = "dibi1g3ce89";
const inputIconWrapper = "dibi15ubmll";
const iconButton = "dibi7m0qpb";
const crossIconWrapper = "dibc14foslh";
const iconCls = "dibi1q9usf6";
const crossIcon = "dibc1jxuim";
const searchSelectors = makeSelectors({
  wrapper: inputWrapper,
  icon: iconCls
});

export { crossIcon, crossIconWrapper, globalThemeSearchButton, iconButton, iconCls, input, inputIconWrapper, inputWrapper, modifiers, searchSelectors };
import "./search.style.linaria.module.css";
//# sourceMappingURL=search.style.js.map
